import SITE_LANGUAGE from "../../partials/siteLanguage";
import algoliasearchlite from "algoliasearch/lite";
import algoliasearch from "algoliasearch";
import instantsearch from "instantsearch.js";


// determine which environment index to use
export const algoliaIndexPrefix = process.env.ENVIRONMENT === "production" ? "prod" : "dev";

const algoliaClient = algoliasearch(
	process.env.ALGOLIA_APP_ID || "",
	process.env.ALGOLIA_PUBLIC_API_KEY || ""
);

const fundDetailIndexName = `${algoliaIndexPrefix}_funds_${SITE_LANGUAGE}`
const fundFamilyIndexName = `${algoliaIndexPrefix}_fundfamilies_${SITE_LANGUAGE}`

export const singleFundIndex = algoliaClient.initIndex(fundDetailIndexName);
export const fundFamilyIndex = algoliaClient.initIndex(fundFamilyIndexName);

// set up the client
export const searchClient = algoliasearchlite(
	process.env.ALGOLIA_APP_ID || "",
	process.env.ALGOLIA_PUBLIC_API_KEY || ""
);

const search = instantsearch({
	indexName: fundFamilyIndexName,
	searchClient
});

export default search;

